import store from "@/store";

type StoreUpdatePayload = {
  module: string;
  state: any;
  mutation: any;
};

export function createStoreEventManager() {
  // moduleName → Map<subscriptionId, callback>
  const moduleRegistry = new Map<
    string,
    Map<string, (payload: StoreUpdatePayload) => void>
  >();

  // single Vuex subscription
  store.subscribe((mutation, state) => {
    const [module] = mutation.type.split("/");

    const subs = moduleRegistry.get(module);
    if (!subs) return;

    const payload: StoreUpdatePayload = { module, state: state[module as keyof typeof state], mutation };
    subs.forEach((callback) => callback(payload));
  });

  const register = (
    modules: string[],
    callback: (payload: StoreUpdatePayload) => void
  ): string => {
    const id = `sub_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    modules.forEach((m) => {
      if (!moduleRegistry.has(m)) {
        moduleRegistry.set(m, new Map());
      }
      moduleRegistry.get(m)!.set(id, callback);
    });
    return id; // unique subscriptionId
  };

  const unregister = (id: string) => {
    moduleRegistry.forEach((subs) => {
      subs.delete(id);
    });
  };

  return { register, unregister };
}
